import { Vars } from './Vars'

export function StepProgress({ current, total, label }) {
  const pct = Math.round((current / total) * 100)
  return (
    <div className="step-progress">
      <div className="step-progress__label">
        <span>Шаг {current} из {total}</span>
        {label && <span className="text-muted">{label}</span>}
      </div>
      <div className="step-progress__track">
        <Vars
          className="step-progress__fill"
          vars={{ '--progress': `${pct}%` }}
          role="progressbar"
          aria-valuenow={current}
          aria-valuemin={1}
          aria-valuemax={total}
        />
      </div>
    </div>
  )
}
